<template>
    <div>
  
      <p v-if="isShowP && !isHtml">{{pMsg}}</p>
      <p v-if="isShowP && isHtml" v-html="$h.removeXSS(msg)"></p>
      <p v-if="isShowSlot"><slot :text="pMsg"></slot></p>
    </div>
</template>

<script>
import lineclamp from '@/assets/js/lineclamp.js'

export default {
  name: 'LineClamp',
  props: {
    line: { type: Number, default: 2 },
    msg: { type: String, required: true },
    isHtml: { type: Boolean, default: false }
  },
  data () {
    return {
      pMsg: this.msg,
      isDot: false,
      isShowP: true,
      isShowSlot: false
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.dot()
    })
  },
  methods: {
    dot () {
      let options = {clamp: this.$props.line}
      let clampedRes = lineclamp(this.$el, options)
      this.pMsg = clampedRes.clamped
      if (this.$scopedSlots.default !== undefined) {
        this.isShowP = false
        this.isShowSlot = true
      }
      this.isDot = clampedRes.clamped !== clampedRes.original
      if (this.isDot) {
        this.$emit('isDot')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LineClamp.vue